export default {
  exclusiveOfferTitle: 'An Exclusive Offer Is Waiting For You',
  exclusiveOfferDesc:
    "Tameeni's special discount on medical malpractice insurance for Doctor Lounge clients.",
  couponLabel: 'Medical Malpractice Coupon',
  copyCoupon: 'Copy coupon',
  buyNow: 'Buy Now',
  remindMeLater: 'Remind me later?',
  backToCouponDetails: 'Back to coupon details',
  reminderFormTitle: 'Please Fill Your Info:',
  email: 'Email',
  emailPlaceholder: 'Email',
  emailExample: 'eg. email@email.com',
  mobile: 'Mobile*',
  mobilePlaceholder: 'Mobile',
  mobileExample: 'eg. 05xxxxxxxx',
  reminderDatePlaceholder: 'Reminder date',
  captchaCode: 'Captcha Code',
  captchaPlaceholder: 'Captcha Code',
  reminderSavedToast: 'Your information saved successfully',
  // Validation messages
  validation: {
    emailRequired: 'Email is required',
    emailInvalid: 'Enter valid Email',
    mobileRequired: 'Mobile number is required',
    mobileInvalid: 'Enter valid 10 digit Mobile No',
    communicationDateRequired: 'Reminder date is required',
    captchaRequired: 'Captcha code is required',
  },
} as const
